import CustomLinks from "@/components/CustomLinks";
import Ad from "@/src/ads/components/Ad";
import clsx from "clsx";
import Image from "next/legacy/image";
import { useState } from "react";

const CreatorHeader = ({
  heading,
  imageSrc,
  biographyIntro,
  biography,
  links,
}: {
  heading: string;
  imageSrc: string;
  biographyIntro: string;
  biography: string;
  links: any;
}) => {
  const [showBiography, setShowBiography] = useState(false);

  return (
    <div
      className={clsx(
        "CreatorHeader",
        "flex h-full grow flex-col md:space-y-12"
      )}
    >
      <div
        className={clsx(
          "CreatorHeader__grid",
          "grid grid-cols-12 gap-6 px-6 md:gap-12 md:px-6 lg:px-12"
        )}
      >
        <div
          className={clsx(
            "CreatorHeader__media",
            "col-span-4 py-6 lg:col-span-4 lg:py-12"
          )}
        >
          <div
            className={clsx(
              "CreatorHeader__image",
              "relative aspect-square overflow-hidden rounded-full md:rounded-2xl lg:aspect-3/4 2xl:aspect-square"
            )}
          >
            {!!imageSrc && (
              <Image
                src={imageSrc}
                alt={heading}
                objectFit="cover"
                layout="fill"
              />
            )}
            {!imageSrc && (
              <div
                className={clsx(
                  "flex h-full w-full items-center justify-center"
                )}
              >
                <div
                  className={clsx("size-full rounded-full bg-zinc-100")}
                ></div>
              </div>
            )}
          </div>
        </div>

        <div
          className={clsx(
            "CreatorHeader__content",
            "col-span-8 py-6 lg:col-span-8 lg:py-12"
          )}
        >
          <div className={clsx("flex flex-1 flex-col")}>
            <div className={clsx("space-y-0.5 md:space-y-3")}>
              <h1 className={clsx("md:heading-sm--spatial font-medium")}>
                {heading}
              </h1>

              <div
                className={clsx(
                  "ChefHeader__desktopBio",
                  "body-text hidden md:block"
                )}
                dangerouslySetInnerHTML={{ __html: biography }}
              ></div>

              <div
                className={clsx(
                  "ChefHeader__mobileBio",
                  "body-text-sm block md:hidden"
                )}
                dangerouslySetInnerHTML={{ __html: biographyIntro }}
              ></div>
            </div>

            <div className={clsx("mt-auto flex items-center pt-6")}>
              <div className={clsx("md:hidden")}>
                <button
                  onClick={() => setShowBiography(!showBiography)}
                  className={clsx(
                    "h-component-sm flex items-center rounded-full px-3 font-body text-xs",
                    {
                      "bg-zinc-900 text-zinc-50": showBiography,
                      "bg-zinc-100 text-zinc-900 hover:bg-zinc-900 hover:text-zinc-50":
                        !showBiography,
                    }
                  )}
                >
                  <div>{showBiography ? "Hide" : "Read"} Bio</div>
                </button>
              </div>
              {links && links.length > 0 && (
                <div className={clsx("max-md:ml-2")}>
                  <CustomLinks
                    links={links}
                    layout="horizontal"
                    withLabels={false}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showBiography && (
        <div
          className={clsx(
            "ChefHeader__mobileBio",
            "body-text-sm block border-t px-6 py-6 font-normal md:hidden"
          )}
          dangerouslySetInnerHTML={{ __html: biography }}
        ></div>
      )}

      {process.env.NEXT_PUBLIC_ADS_PROVIDER === "hashtaglabs" && (
        <Ad placementName={"htlad-ros_top"} className="py-6 lg:py-12" />
      )}
    </div>
  );
};

export default CreatorHeader;
